import Cookies from "js-cookie";
import { Auth } from "aws-amplify";

const BASE_URL = process.env.REACT_APP_API_URL
const COGNITO_DOMAIN = process.env.REACT_APP_USER_POOL_DOMAIN_URL

const defaultHeaders = {
  'Content-Type': 'application/json',
};




const request = async (url, method, data = null, customHeaders = {}) => {

  const headers = { ...defaultHeaders, ...customHeaders }

  const options = {
    method,
    headers,
    credentials: "include",
    body: data ? JSON.stringify(data) : undefined,
  }

  try {
    const response = await fetch(`${BASE_URL}${url}`, options)


    // Handle authentication errors
    if ([401, 403].includes(response.status)) {
      logout();
      throw new Error("Unauthorized or forbidden. You have been logged out.");
    }

    // Handle other HTTP errors
    if (!response.ok) {
      let errorMessage = "Something went wrong!";
      try {
        const errorData = await response.json(); // Attempt to parse the error response
        errorMessage = errorData.message || errorMessage; // Use server-provided error message if available
      } catch (parseError) {
        console.warn("Failed to parse error response:", parseError);
      }

      // Throw an enhanced error
      throw new Error(`${response.status} ${response.statusText}: ${errorMessage}`);
    }

    // Return parsed JSON data
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);

    // Return a detailed error message
    throw new Error(error.message || "Something went wrong while processing the request.");
  }
}

  const logout = async () => {
    try {
      await Auth.signOut();

      Cookies.remove('idToken');
      Cookies.remove('email', { path: '/' });
      Cookies.remove('user', { path: '/' });
      Cookies.remove('accessToken');
      Cookies.remove('role', { path: '/' });
      Cookies.remove('tenantId', { path: '/' });

      const ssoIssuer = localStorage.getItem('ssoIssuer');
      const ssoClientId = localStorage.getItem('ssoClientId');
      const tenantLoginUrl = localStorage.getItem('tenantLoginUrl');

      localStorage.removeItem('email');
      localStorage.removeItem('user');
      localStorage.removeItem('tenantId');
      localStorage.removeItem('ssoIssuer');
      localStorage.removeItem('ssoClientId');
      localStorage.removeItem('tenantLoginUrl');

      if (ssoIssuer && ssoClientId && COGNITO_DOMAIN) {
        sessionStorage.setItem('logoutIssuer', ssoIssuer);
        sessionStorage.setItem('logoutLoginUrl', tenantLoginUrl || '');
        const cognitoDomain = COGNITO_DOMAIN.endsWith('/') ? COGNITO_DOMAIN.slice(0, -1) : COGNITO_DOMAIN;
        const logoutUrl = `${cognitoDomain}/logout?client_id=${ssoClientId}&logout_uri=${window.location.origin}/logout-complete`;
        window.location.href = logoutUrl;
        return;
      }

      window.location.href = '/';
    } catch (error) {
      console.error('Error during sign out:', error);
    }
  }


  export const get = (url, customHeaders = {}) => request(url, 'GET', null, customHeaders);
  export const post = (url, data, customHeaders = {}) => request(url, 'POST', data, customHeaders);
  export const put = (url, data, customHeaders = {}) => request(url, 'PUT', data, customHeaders);
  export const del = (url, customHeaders = {}, data = null) => request(url, 'DELETE', data, customHeaders);